export default __webpack_public_path__ + "static/media/clicknbox.46e1f6d6.svg";